import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const SHOWER_DOORS_FAQS = [{
  question: 'Do you install custom glass shower doors near me?',
  answer: "Kosin's Glass installs custom shower doors and glass shower enclosures throughout Howell, Ann Arbor, Novi and Southeast Michigan. Request a free in-home quote and the team will confirm availability for your location."
}, {
  question: 'What is a frameless or Euro glass shower door?',
  answer: 'A frameless or Euro glass shower door uses thick tempered glass and minimal hardware instead of a bulky frame. The result is a clean, open look that helps showcase tile, stone and bathroom finishes.'
}, {
  question: 'Do you install semi-frameless, framed and sliding shower doors?',
  answer: "Yes. Kosin's Glass offers frameless, Euro, semi-frameless, framed, sliding, bypass, tub enclosure, fixed-panel and walk-in shower glass options."
}, {
  question: 'Can you replace an existing glass shower door?',
  answer: "Yes. Kosin's Glass can review an outdated, damaged, leaking or poorly fitting shower door and recommend replacement or repair options based on the opening and condition of the glass and hardware."
}, {
  question: 'How much do custom glass shower doors cost?',
  answer: "Pricing depends on the shower opening, glass size and thickness, door style, hardware finish, glass texture, protective coating and installation requirements. Kosin's Glass provides a free in-home quote after reviewing your project."
}, {
  question: 'When should shower glass be measured during a bathroom remodel?',
  answer: "Contact Kosin's Glass early for planning help. Final measurements are usually taken after key finished surfaces are complete so the glass can be fabricated to the exact opening."
}, {
  question: 'What glass and hardware options can I choose?',
  answer: "Kosin's Glass offers 18 glass designs and textures plus many hardware finishes, colors and styles. Options may include clear, frosted, rain, reeded, textured or tinted glass depending on availability and project needs."
}, {
  question: 'Are frameless shower doors hard to clean?',
  answer: 'Frameless shower doors have fewer frame edges and crevices than traditional framed doors, which can make cleaning easier. Ask about optional protective coatings that help reduce water spots and soap scum.'
}, {
  question: 'Do glass shower doors leak?',
  answer: "Professional measurement, proper layout, quality hardware and clean installation help improve water containment. Because every shower is different, Kosin's Glass can review your layout and explain the best enclosure option."
}, {
  question: 'Do you work with bathroom remodelers and contractors?',
  answer: "Yes. Kosin's Glass works with homeowners, remodelers, designers, builders and contractors on custom shower glass projects."
}];
export function ShowerDoorsFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-109">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-110">
        <div className="text-center mb-12 anim-on-scroll" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-112">
            Glass Shower Door Questions
          </h2>
        </div>
        <div className="anim-on-scroll space-y-4" data-id="element-113">
          {SHOWER_DOORS_FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          const panelId = `shower-faq-panel-${idx}`;
          const buttonId = `shower-faq-button-${idx}`;
          return <div key={idx} className={`border rounded-xl transition-colors ${isOpen ? 'border-primary/30 bg-glass/40' : 'border-gray-200 bg-white'}`} data-id="element-114">
                <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl" data-id="element-115">
                  <span className="text-lg font-bold text-navy pr-8" dangerouslySetInnerHTML={{
                __html: item.question
              }} data-id="element-116" />
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-primary' : 'text-gray-400'}`} aria-hidden="true" data-id="element-117" />
                </button>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-118">
                  <div className="overflow-hidden" data-id="element-119">
                    <div className="px-6 pb-6 text-gray-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
                  __html: item.answer
                }} data-id="element-120" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}